import React from 'react';
import './index.scss';

export default () => {
  return <div className="bottom-bar" />;
}
